import {
  calculatePresetDateRange,
  getPresetLabel,
} from "@/utils/date/dateRange"
import {
  DATE_RANGE_PRESET,
  type DateRange,
  type DateRangePreset,
} from "@/utils/date/dateRangeTypes"

interface DateRangePresetConfig {
  key: DateRangePreset
  label: string
  calculateRange: () => DateRange
  isCustom: boolean
}

/**
 * The presets whose range the user supplies, so Quick Select leaves them out
 * and the surfaces that collect one offer their own entry point.
 */
const CUSTOM_PRESETS: readonly DateRangePreset[] = [
  DATE_RANGE_PRESET.CUSTOM_FIXED,
  DATE_RANGE_PRESET.CUSTOM_RELATIVE,
  DATE_RANGE_PRESET.CUSTOM_UNTIL_NOW,
]

/**
 * Every preset a dashboard can carry, in the order Quick Select offers them.
 *
 * The keys are this surface's own — saved dashboards persist them — but both
 * the wording and the span behind each one come from the shared registry, so
 * a dashboard's "Last 7 days" reads and covers the same as a date filter's.
 */
export const getAllPresetConfigs = (): DateRangePresetConfig[] =>
  Object.values(DATE_RANGE_PRESET).map((key) => ({
    key,
    label: getPresetLabel(key),
    calculateRange: () => calculatePresetDateRange(key),
    isCustom: CUSTOM_PRESETS.includes(key),
  }))
